t = require('views/internal/teacup-with-helpers')('header_warning_account_transfer_required_collapsed')

module.exports = t.renderable ({ overdue, remainingDays, enterpriseName }) ->
  t.p '.u-bottom', ->
    t.p ->
      if overdue
        t.format 'account-conversion-overdue'
      else
        t.format 'account-conversion-days-remaining', { remainingDays }

      t.text '. '
      t.a '.quiet', { href: "/enterprise/#{ enterpriseName }/transfer-account" }, ->
        if overdue
          t.format 'convert-now'
        else
          t.format 'start-conversion'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/header_warning_account_transfer_required_collapsed.coffee